<template>
    <div class="sub-card">
        <div v-if="blogPost != [] && blogPost.length > 0">
            <div class="card-inner">
                <div class="sub-card-top">
                    <i class="fal fa-book-open light-text"></i>
                    <h3 class="bold-text light-text">{{ settings['blogcomponent_name'] }}</h3>
                </div>
                <a :href="post.link" target="_blank" v-for="post in blogPost" class="blogpost-sidebar">

                    <div class="blog-image-box">
                        <img v-if="post.blog_image !== false" v-bind:src="post.blog_image" class="blogpost-image-sidebar">
                    </div>

                    <div class="blog-info-box">
                        <span class="blog-title-text normal-text bold-text">{{post.title}}</span>
                        <span class="blog-date light-text">- {{post.date}}</span>
                    </div>

                </a>


                <div class="all-members-link">
                    <a :href="this.blogurl" target="_blank" class="secondary-c tiny-text inline-block">{{ translations['blog.more'] }}</a>
                    <i class="fa fa-caret-right secondary-c tiny-text"></i>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Global from '../mixins/Global.js'

    export default {
        mixins: [Global],
        name: "BlogFeed",

        props: ['insidebar','blogurl'],

        computed: {
            // Grab these states from store.
            ...mapState([
                'settings',
                'blogPost',
                'emptyBlogImage',
            ]),
        },

        mounted() {
            this.$store.dispatch('getBlogPosts');
        },

        updated() {
            if(typeof stickySidebar !== 'undefined') {
                stickySidebar.init();
            }
        },
    }
</script>

<style lang="scss" scoped>

    .blogpost-sidebar{
        margin-bottom:5px;
        display: flex;


        .blogpost-image-sidebar{
            width: 80px;
            object-fit: cover;
            height: 40px;
            border-radius: 5px;
        }


        .blog-info-box{
            padding-left:8px;
            width: 100%;

            span{
                font-size: .8em;
            }

            .blog-date {
                padding-left: 4px;
            }
        }

        &:hover{
            text-decoration:underline;
        }
    }

</style>